import linkifyHtml from 'linkify-html'
import DOMPurify from 'isomorphic-dompurify'
import React, { type JSX } from 'react'

export function RichTextDisplay<As extends keyof JSX.IntrinsicElements = 'div'>({
  as: Comp = 'div',
  children,
  linkify,
  ...props
}: {
  as?: keyof JSX.IntrinsicElements
  children?: string | null | undefined
  linkify?: Parameters<typeof linkifyHtml>[1]
} & Omit<React.ComponentProps<As>, 'children'>) {
  const purified = React.useMemo(() => DOMPurify.sanitize(children ?? ''), [children])
  const linkified = React.useMemo(() => {
    if (linkify) {
      return linkifyHtml(purified, linkify)
    } else {
      return purified
    }
  }, [purified, linkify])
  return React.createElement(Comp, {
    dangerouslySetInnerHTML: { __html: linkified },
    ...props
  })
}
